import { useEffect } from "react";
import { useLazyFetchProfileQuery } from "../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import { updateQuickActionMenuData } from "../features/Feature_GeneralAppElements/GeneralAppElements_Slice";
import {
  useAppDispatch,
  useAppSelector,
} from "../redux-store/CustomReduxHooks";
import { setError } from "../redux-store/reducers/CsErrorSlice";
import staticProfileHamburgerMenuData from "../assets/testData/ProfileHamburgerMenuData.json";
import { R_LoginRoutes } from "../utils/Routes";

const useQuickActionMenu = () => {
  const [fetchProfileApi] = useLazyFetchProfileQuery();
  const userDetails = useAppSelector((state) => state.CsAppSlice).userDetails;
  const internalAuthToken = useAppSelector(
    (state) => state.CsAppSlice.tokenDetails?.internal
  );
  const appDispatch = useAppDispatch();

  useEffect(() => {
    const fetchProfiles = async () => {
      if (
        userDetails?.customerAndLobDetails &&
        userDetails?.customerAndLobDetails.length > 0
      ) {
        try {
          const profileResponses = await Promise.all([
            ...userDetails.customerAndLobDetails.map(async (element) => {
              const response = await fetchProfileApi({
                csUserId: userDetails.CS_USER_ID,
                moduleId: element.LOB_CODE,
              });
              return {
                [element.LOB_CODE]: response.data?.payload.menuDetailsList,
              };
            }),
            // Static API call for LOB_CODE: 111 - Hamburger menu
            (async () => {
              const response = await fetchProfileApi({
                csUserId: userDetails.CS_USER_ID,
                moduleId: "111",
              });
              return {
                "111":
                  response.data?.payload &&
                  Array.isArray(response.data?.payload.menuDetailsList) &&
                  response.data?.payload?.menuDetailsList.length > 0
                    ? response.data?.payload.menuDetailsList
                    : staticProfileHamburgerMenuData,
              };
            })(),
          ]);

          const responseByLobCode = profileResponses.reduce(
            (acc, curr) => ({ ...acc, ...curr }),
            {}
          );

          appDispatch(updateQuickActionMenuData(responseByLobCode));
        } catch (err) {
          appDispatch(
            setError({
              error: new Error(),
              message: "failed",
            })
          );
        }
      } else {
        const response = await fetchProfileApi({
          csUserId: userDetails?.CS_USER_ID ?? "",
          moduleId: "111",
        });
        const responseByLobCode = {
          "111":
            response.data?.payload &&
            Array.isArray(response.data?.payload.menuDetailsList) &&
            response.data?.payload?.menuDetailsList.length > 0
              ? response.data?.payload?.menuDetailsList
              : staticProfileHamburgerMenuData,
        };
        appDispatch(updateQuickActionMenuData(responseByLobCode));
        return;
      }
    };
    if (!window.location.pathname.includes(R_LoginRoutes.login))
      fetchProfiles();
  }, [
    internalAuthToken,
    userDetails?.customerAndLobDetails,
    userDetails?.CS_USER_ID,
    window.location,
  ]);
};

export default useQuickActionMenu;
